import React from 'react';
import Button from '../../common/Button';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta">
      <div className="container">
        <div className="cta-content">
          <h2>Unlock Unprecedented Opportunities Today</h2>
          <p>Contact Literally Possible today to start your transformative journey toward innovation and success. Our experts are ready to help.</p>
          <Button variant="primary" size="large">
            Schedule a Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA; 